import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || '';

// Clean up old/duplicate auth tokens from localStorage
// This fixes the issue where multiple storage keys cause auth to hang
if (typeof window !== 'undefined' && window.localStorage) {
  const oldKey = 'supabase.auth.token';
  const correctKey = `sb-${supabaseUrl.split('//')[1]?.split('.')[0]}-auth-token`;

  // If we have the old key, remove it
  if (localStorage.getItem(oldKey)) {
    localStorage.removeItem(oldKey);
  }

  // Check for any other supabase auth keys that don't match the correct pattern
  // IMPORTANT: Don't remove code-verifier keys - they're needed for PKCE OAuth flow
  const codeVerifierKey = `${correctKey}-code-verifier`;
  Object.keys(localStorage).forEach(key => {
    // Only remove keys that are:
    // 1. Old format (supabase.auth)
    // 2. Wrong project auth tokens (sb-XXX-auth-token but not our project)
    // 3. The literal "undefined" key
    // DO NOT remove code-verifier keys!
    if (
      key.startsWith('supabase.auth') ||
      (key.startsWith('sb-') && key.includes('auth-token') && key !== correctKey && key !== codeVerifierKey) ||
      key === 'undefined'
    ) {
      localStorage.removeItem(key);
    }
  });
}

// Create client with appropriate storage based on environment
export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      storage: typeof window !== 'undefined' ? window.localStorage : undefined,
      flowType: 'pkce', // Use PKCE flow for better security
    },
  }
);